<style>
    :root {
        --video-button-color: var(--primary-blue-400, red);
        --video-button-background: var(--background, white);
    }

    .video-input {
        display: inline-block;
        max-width: 100%;
        position: relative;
    }

    .video-input__preview {
        display: block;
        height: auto;
        max-width: 100%;
    }

    .video-input__preview:not([data-disabled]) {
        cursor: -webkit-grab;
    }

    .video-input__preview:not([data-disabled]):active {
        cursor: -webkit-grabbing;
    }

    .video-input__label {
        border: 1px solid #cccccc;
        border-radius: 5px;
        display: block;
        max-width: 100%;
    }

    .video-input__input {
        left: 0;
        position: fixed;
        top: 100%;
    }
    input.video-input__input{
      display:none !important;
    }

    .video-input__slider {
        width: 200px;
    }

    @media only screen and (min-width: 768px) and (max-width: 1023px) {
        div.video-input.comment div label div.video-input__content {
            justify-content: center !important;
        }
    }

    @media only screen and (max-width: 768px) {
        .video-input__slider {
            width: 180px;
        }
        div.video-input.comment div label div.video-input__content {
            justify-content: center !important;
        }
    }

    .video-input__content {
        align-items: left;
        bottom: 0;
        display: flex;
        justify-content: left;        

    }

    .video-input__error {
        color: var(--highlight);
        font-size: 0.8em;
        font-weight: bold;
        margin-bottom: 0.5em;
        margin-top: 0.5em;
        text-align: center;
    }

    .icon-video{
        color: var(--video-button-color);
        border:0;
        font-size: 1.7em; 
        padding: 0 10px;   
    }

    .icon-video span.cp-icon__container {
        position: initial !important;
    }

    div.video-input.comment div label div.video-input__content div.video-input__content-container span.icon-video {
        color: gray;
        cursor: pointer;
        padding: 0;
    }

    div.video-input.comment div label div.video-input__content {
        justify-content: left;
    }
    .video-width {
        width: 100%;
    }

</style>

<template>
    <div class="video-input">
        <div v-if="value.video" :style="[icon ? {width: `100%`} : {width: `${width}px`}]">
             <video class="candidate-video-player" :class="[inputGroup ? 'video-width' : '']" controls preload="metadata">
                <source :src="`${value.video}#t=0.1`" type="video/mp4" />                
            </video>
            <div>
                <cp-button @click="clearvideo">{{ clearLabel }}</cp-button>
            </div>
        </div>

        <div v-else>
            <div v-if="error" class="video-input__error">{{ error }}</div>                        
            <label :class="[icon ? '' : 'video-input__label']" >
                <div class="video-input__height-provider"></div>
                <div class="video-input__content">
                    <div class="video-input__content-container">
                        <input type="file" v-if="!resettingFileInput" class="video-input__input" accept="video/*" :disabled="disabled" @change="handleFileChange" />
                        <slot>
                            <span v-if="icon" class="icon-video">
                                <cp-icon name="video"></cp-icon>
                            </span>                                
                            <span v-else>
                                <cp-button-base>
                                    {{ selectLabel }}
                                </cp-button-base>
                            </span>
                        </slot>
                    </div>
                </div>
            </label>
        </div>        
    </div>
</template>

<script>
   
    function getvideoDataURL(file) {
        return new Promise(resolve => {
            const reader = new FileReader();
            reader.onload = () => resolve(reader.result);
            reader.readAsDataURL(file);
        });
    }

    export default {
        directives: {
            margin: require('../directives/margins').margin,
            marginBottom: require('../directives/margins').marginBottom,
            marginTop: require('../directives/margins').marginTop,
        },

        components: {
            CpButton: require('../button').default,
            CpButtonBase: require('../button-base').default,
            CpGrid: require('../grid').default,
            CpGridItem: require('../grid-item').default,
            CpIcon: require('../icon').default
        },

        props: {
            value: { type: Object, default() { return this.makeEmptyValue(); } },
            width: { type: Number, default: 100 },
            height: { type: Number, default: 100 },
            margin: { type: Number, default: 20 },
            circular: { type: Boolean, default: false }, // For display only. The crop is still stored as the bounding rectangle because the video will be made round with CSS.
            mask: { type: String, default: 'rgba(0, 0, 0, 0.5)' },
            selectLabel: { type: String, default: 'Select a video' },
            clearLabel: { type: String, default: 'Remove' },
            disabled: Boolean,
            icon:{ type: Boolean, default: false },
            inputGroup: { type: Boolean, default: false },
        },

        data() {
            return {
                error: null,
                resettingFileInput: false,
                naturalWidth: 0,
                naturalHeight: 0,
                dragState: null,
                maxlength: 25000000, 
            };
        },

        computed: {
            videoIsTallerThanInput() {
                const videoAspectRatio = this.naturalWidth / this.naturalHeight;
                const inputAspectRatio = this.width / this.height;
                return videoAspectRatio < inputAspectRatio;
            },
             currentCoords() {
                // Provide sensible centered coords if none are set.
                let {x, y, width, height} = this.value;
                if (!x && x !== 0) x = this.videoIsTallerThanInput ? 0 : (this.naturalWidth - this.width / this.height * this.naturalHeight) / 2;
                if (!y && y !== 0) y = this.videoIsTallerThanInput ? (this.naturalHeight - this.height / this.width * this.naturalWidth) / 2 : 0;
                if (!width && width !== 0) width = this.videoIsTallerThanInput ? this.naturalWidth : this.width / this.height * this.naturalHeight;
                if (!height && height !== 0) height = this.videoIsTallerThanInput ? this.height / this.width * this.naturalWidth : this.naturalHeight;
                return {x, y, width, height};
            },

            currentMargin() {
                return this.disabled ? 0 : this.margin;
            },
        },

        methods: {
            makeEmptyValue() {
                return { video: null, x: null, y: null, width: null, height: null };
            },

            async handleFileChange(event) {
                try {
                    this.error = null;
                    const file = event.target.files[0];
                    if (file) {
                        if(file.size > this.maxlength){
                            this.error = 'Sorry, the file exceeds the maximum allowed upload size.';                        
                        }
                        else{
                            const urlGetter = getvideoDataURL;
                            const dataURL = await urlGetter(file);
                            const newValue = Object.assign({video: dataURL}, {name:file.name},  this.currentCoords);
                            this.emitChange(newValue);
                        }
                    }
                } catch (error) {
                    console.log(error);
                    this.error = 'Sorry, there was an error reading that file.';
                } finally {
                    this.resetFileInput();
                }
            },

            resetFileInput() {
                // Destroy and recreate the file input between selections to clear its value.
                this.resettingFileInput = true;
                setTimeout(() => {
                    this.resettingFileInput = false;
                });
            },

            handleStart(event) {
                if (this.disabled) {
                    return;
                }

                event.preventDefault();

                const isTouch = event.type.indexOf('touch') === 0;
                const pointer = isTouch ? event.touches[0] : event;
                this.dragState = {
                    isTouch,
                    startPageX: pointer.pageX,
                    startPageY: pointer.pageY,
                    startValueX: this.value.x,
                    startValueY: this.value.y,
                };

                addEventListener(isTouch ? 'touchmove' : 'mousemove', this.handleMove);
                addEventListener(isTouch ? 'touchend' : 'mouseup', this.handleRelease);
                addEventListener('touchcancel', this.handleRelease);
            },

            clearvideo() {
                const emptyValue = this.makeEmptyValue();
                this.emitChange(emptyValue);
            },

            emitChange(changes) {
                const value = Object.assign({}, this.value, changes);
                this.$emit('input', value);
            },
        },        
    };
</script>
